<div>
  @if (multiRowDatatableFlag) {
    <LOSx-datatable-multi-row
      [entityType]="entityType"
      [entityId]="entityId"
      [dataObject]="entityDatatable"
    ></LOSx-datatable-multi-row>
  }
  @if (!multiRowDatatableFlag) {
    <LOSx-datatable-single-row
      [entityType]="entityType"
      [entityId]="entityId"
      [dataObject]="entityDatatable"
    ></LOSx-datatable-single-row>
  }
</div>
